import { BoardType } from "./board-type.constant";

export interface CrmListColumnTemplate {
  id: string;
  nameKey: string;
  percentage?: number;
  addToProbability?: boolean;
}

export const CRM_BUSINESS_COLUMN_TEMPLATES: CrmListColumnTemplate[] = [
  {
    id: "prospect",
    nameKey: "app.crmList.template.prospect",
    percentage: 5,
    addToProbability: true,
  },
  {
    id: "qualified-lead",
    nameKey: "app.crmList.template.qualifiedLead",
    percentage: 10,
    addToProbability: true,
  },
  {
    id: "contacted",
    nameKey: "app.crmList.template.contacted",
    percentage: 20,
    addToProbability: true,
  },
  {
    id: "meeting-scheduled",
    nameKey: "app.crmList.template.meetingScheduled",
    percentage: 30,
    addToProbability: true,
  },
  {
    id: "meeting",
    nameKey: "app.crmList.template.meeting",
    percentage: 40,
    addToProbability: true,
  },
  {
    id: "waiting-response",
    nameKey: "app.crmList.template.waitingResponse",
    percentage: 45,
    addToProbability: true,
  },
  {
    id: "follow-up",
    nameKey: "app.crmList.template.followUp",
    percentage: 50,
    addToProbability: true,
  },
  {
    id: "proposal",
    nameKey: "app.crmList.template.proposal",
    percentage: 60,
    addToProbability: true,
  },
  {
    id: "negotiation",
    nameKey: "app.crmList.template.negotiation",
    percentage: 80,
    addToProbability: true,
  },
  {
    id: "onboarding",
    nameKey: "app.crmList.template.onboarding",
    percentage: 90,
    addToProbability: true,
  },
  {
    id: "won",
    nameKey: "app.crmList.template.won",
    percentage: 100,
    addToProbability: true,
  },
  {
    id: "lost",
    nameKey: "app.crmList.template.lost",
    percentage: 0,
    addToProbability: false,
  },
];

export const CRM_ACTIVITY_COLUMN_TEMPLATES: CrmListColumnTemplate[] = [
  { id: "backlog", nameKey: "app.crmList.template.backlog" },
  { id: "todo", nameKey: "app.crmList.template.todo" },
  { id: "in-progress", nameKey: "app.crmList.template.inProgress" },
  { id: "review", nameKey: "app.crmList.template.review" },
  { id: "blocked", nameKey: "app.crmList.template.blocked" },
  { id: "waiting-client", nameKey: "app.crmList.template.waitingClient" },
  { id: "done", nameKey: "app.crmList.template.done" },
  { id: "cancelled", nameKey: "app.crmList.template.cancelled" },
];

export const getCrmListColumnTemplates = (boardType?: string) =>
  boardType === BoardType.BUSINESS
    ? CRM_BUSINESS_COLUMN_TEMPLATES
    : CRM_ACTIVITY_COLUMN_TEMPLATES;
